import { ApiService } from "../../../../services/api.service"
import { LocalStorageUtility } from "../../../../util/localStorageUtility"
import { logout } from "./logout"

/**
 * @function aliasLogout - Function to logout from the aliased user
 * @param setState - hook to set the Auth context state
 * @param removeCookie - hook to remove cookies
 */
export const aliasLogout = (setState, removeCookie) => {
  ApiService.post(process.env.ALIAS_LOGOUT).then((res: any) => {
    if (res.status === 200 && typeof window !== "undefined") {
      window.location.replace("/dashboard")
      LocalStorageUtility.removeLocalStorage()
    } else {
      logout(removeCookie, setState)
    }
  })
}
